<template>
<ul class="vehicle-search__filter-pills">
                    <li v-for="(value, index) in brands" :key="index">
                        <button :aria-label="`Fjern mærke filter: ${value}`"
                            @click="emitChange('brands',brands.slice(0, index).concat(brands.slice(index + 1)))">
                            <span>{{ getBrandDisplayNameForFilterPills(value) }}</span></button>
                    </li>
                    <li v-for="(value, index) in models" :key="index">
                        <button :aria-label="`Fjern model filter: ${value}`"
                            @click="emitChange('models', models.slice(0, index).concat(models.slice(index + 1)))"><span>{{ value
                            }}</span></button>
                    </li>
                    <li v-for="(value, index) in segments" :key="index">
                        <button :aria-label="`Fjern type filter: ${value}`"
                            @click="emitChange('segments',segments.slice(0, index).concat(segments.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-if="query != null && query.length > 0">
                        <button :aria-label="`Fjern søgefilter: ${query}`" @click="emitChange('query',null)">{{
                            `"${query}"`
                            }}</button>
                    </li>
                    <li v-for="(value, index) in equipments" :key="index">
                        <button :aria-label="`Fjern udstyr filter: ${value}`"
                            @click="emitChange('equipments',equipments.slice(0, index).concat(equipments.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-for="(value, index) in leasingTypes" :key="index">
                        <button :aria-label="`Fjern leasingtype filter: ${value}`"
                            @click="emitChange('leasingTypes',leasingTypes.slice(0, index).concat(leasingTypes.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-for="(value, index) in modelYears" :key="index">
                        <button :aria-label="`Fjern modelår filter: ${value}`"
                            @click="emitChange('modelYears',modelYears.slice(0, index).concat(modelYears.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-for="(value, index) in firstRegistrationYears" :key="index">
                        <button :aria-label="`Fjern registreringsår filter: ${value}`"
                            @click="emitChange('firstRegistrationYears',firstRegistrationYears.slice(0, index).concat(firstRegistrationYears.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-for="(value, index) in fuelTypes" :key="index">
                        <button :aria-label="`Fjern drivlinje filter: ${value}`"
                            @click="emitChange('fuelTypes',fuelTypes.slice(0, index).concat(fuelTypes.slice(index + 1)))">{{
                                VueHelpers.getFuelTypeDisplayName(value) }}</button>
                    </li>
                    <li v-for="(value, index) in dealerCities" :key="index">
                        <button :aria-label="`Fjern by filter: ${value}`"
                            @click="emitChange('dealerCities',dealerCities.slice(0, index).concat(dealerCities.slice(index + 1)))">{{
                                value }}</button>
                    </li>
                    <li v-if="minPrice != null && minPrice != 0">
                        <button :aria-label="`Fjern minimum pris filter: ${value} kr.`"
                            @click="emitChange('minPrice',null)">{{ dictionary.VehicleSearchFilterPriceMinLabel
                            }} {{ parseInt(minPrice).toLocaleString('da-DK') }} kr.</button>
                    </li>
                    <li v-if="maxPrice != null">
                        <button :aria-label="`Fjern maksimum pris filter: ${value} kr.`"
                            @click="emitChange('maxPrice',null)">{{ dictionary.VehicleSearchFilterPriceMaxLabel
                            }} {{ parseInt(maxPrice).toLocaleString('da-DK') }} kr.</button>
                    </li>
                    <li v-if="minClockedKilometers != null && minClockedKilometers != 0">
                        <button :aria-label="`Fjern nedre kilometer kørt  filter: ${value} km`"
                            @click="emitChange('minClockedKilometers',null)">{{
                                dictionary.VehicleSearchFilterClockedKilometersLabel}} - {{
                                    dictionary.VehicleSearchFilterClockedKilometersMinLabel }} {{
                                parseInt(minClockedKilometers).toLocaleString('da-DK') }} km</button>
                    </li>
                    <li v-if="maxClockedKilometers != null">
                        <button :aria-label="`Fjern øvre kilometer kørt filter: ${value} km`"
                            @click="emitChange('maxClockedKilometers',null)">{{
                                dictionary.VehicleSearchFilterClockedKilometersLabel}} - {{
                                    dictionary.VehicleSearchFilterClockedKilometersMaxLabel }} {{
                                parseInt(maxClockedKilometers).toLocaleString('da-DK') }} km</button>
                    </li>
                    <li v-if="minRange != null && minRange != 0">
                        <button :aria-label="`Fjern nedre elektrisk rækkevidde filter: ${value} km`"
                            @click="emitChange('minRange',null)">{{ dictionary.VehicleFilterRangeLabel }} - {{
                                dictionary.VehicleFilterRangeMinLabel }} {{
                                parseInt(minRange).toLocaleString('da-DK') }} km</button>
                    </li>
                    <li v-if="maxRange != null">
                        <button :aria-label="`Fjern øvre elektrisk rækkevidde filter: ${value} km`"
                            @click="emitChange('maxRange',null)">{{ dictionary.VehicleFilterRangeLabel }} - {{
                                dictionary.VehicleFilterRangeMaxLabel }} {{
                                parseInt(maxRange).toLocaleString('da-DK') }} km</button>
                    </li>
                    <li v-if="minBatteryCapacity != null && minBatteryCapacity != 0">
                        <button :aria-label="`Fjern nedre batterikapacitet filter: ${value} kWh`"
                            @click="emitChange('minBatteryCapacity',null)">{{ dictionary.VehicleFilterBatteryCapacityLabel }} - {{
                                dictionary.VehicleFilterBatteryCapacityMinLabel }} {{
                                parseInt(minBatteryCapacity).toLocaleString('da-DK') }} kWh</button>
                    </li>
                    <li v-if="maxBatteryCapacity != null">
                        <button :aria-label="`Fjern øvre batterikapacitet filter: ${value} kWh`"
                            @click="emitChange('maxBatteryCapacity',null)">{{ dictionary.VehicleFilterBatteryCapacityLabel }} - {{
                                dictionary.VehicleFilterBatteryCapacityMaxLabel }} {{
                                parseInt(maxBatteryCapacity).toLocaleString('da-DK') }} kWh</button>
                    </li>
                    <li v-if="minElectricConsumption != null && minElectricConsumption != 0">
                        <button :aria-label="`Fjern nedre elforbrug filter: ${value} Wh/km`"
                            @click="emitChange('minElectricConsumption',null)">{{ dictionary.VehicleSearchFilterElectricConsumptionLabel }} - {{
                                dictionary.VehicleSearchFilterElectricConsumptionMinLabel }} {{
                                parseInt(minElectricConsumption).toLocaleString('da-DK') }} Wh/km</button>
                    </li>
                    <li v-if="maxElectricConsumption != null">
                        <button :aria-label="`Fjern øvre elforbrug filter: ${value} Wh/km`"
                            @click="emitChange('maxElectricConsumption',null)">{{ dictionary.VehicleSearchFilterElectricConsumptionLabel }} - {{
                                dictionary.VehicleSearchFilterElectricConsumptionMaxLabel }} {{
                                parseInt(maxElectricConsumption).toLocaleString('da-DK') }} Wh/km</button>
                    </li>
                </ul>
</template>
<script>
import VueHelpers  from './../vueHelpers';

export default {
    name: "vehicleSearchFilterPills",
    props:[
        'dictionary',
        'brandFacets',
        'brands',
        'models',
        'segments',
        'query',
        'equipments',
        'leasingTypes',
        'modelYears',
        'firstRegistrationYears',
        'fuelTypes',
        'dealerCities',
        'minPrice',
        'maxPrice',
        'minClockedKilometers',
        'maxClockedKilometers',
        'minRange',
        'maxRange',
        'minBatteryCapacity',
        'maxBatteryCapacity',
        'minElectricConsumption',
        'maxElectricConsumption'
    ],
    data(){
        return {
            VueHelpers:VueHelpers
        }
    },
    methods: {
        emitChange(name,value){
            this.$emit('filterPillDismiss',{name,value});
        },
        getBrandDisplayNameForFilterPills(id) {
            return this.brandFacets.find(x => x.value.id == id).value.displayName;
        },
    }
};
</script>
